import { useEffect, useState } from "@wordpress/element"
import Modal from "../../../../componentsNew/Modal"
import Calendar from "../../../../componentsNew/Calendar";
import { differenceInDays, getDaysInMonth, addMonths, subMonths, format } from "date-fns";
import CardDashGrafico from "../CardDashGrafico";
import Typography from "../../../../componentsNew/Typography";
import { useGetMediasArtigo, useGetMediasDetalhes } from "../../../../api/controllers/artigo";
import ItemTabelaVisaoGeral from "../ItemTabelaVisaoGeral";
import { useSelect } from "@wordpress/data";
import { store } from "../../../../redux/store";


export default function ModalDetalhamentoArtigo({ open, setOpen, idArtigo }) {
    const idBlog = useSelect(select => select(store).getBlogIdOpti())
    const [dataInicial, setDataInicial] = useState(new Date((new Date()).setMonth((new Date()).getMonth() - 1)));
    const [dataFinal, setDataFinal] = useState(new Date());
    const { data: dataGrafico, isLoading } = useGetMediasArtigo(idArtigo, idBlog, dataInicial, dataFinal)
    const { data } = useGetMediasDetalhes(idArtigo)

    useEffect(() => {
        if (Math.abs(differenceInDays(dataInicial, dataFinal)) > getDaysInMonth(dataInicial))
            setDataFinal(addMonths(dataInicial, 1))
    }, [dataInicial]);

    useEffect(() => {
        if (Math.abs(differenceInDays(dataInicial, dataFinal)) > getDaysInMonth(dataFinal))
            setDataInicial(subMonths(dataFinal, 1))
    }, [dataFinal]);
    return (
        <div >
            <Modal open={open} setOpen={setOpen} className="w-modal max-h-[80vh] overflow-auto" titulo="Detalhamento de resultados do Artigo">
                <div className='grid grid-cols-2 gap-4 mt-6'>
                    <Calendar
                        className="w-full"
                        label="Período Inicial"
                        selectedDate={dataInicial}
                        setSelectedDate={setDataInicial} 
                        loading={isLoading}
                        />
                    <Calendar
                        className="w-full"
                        label="Período Final"
                        selectedDate={dataFinal}
                        setSelectedDate={setDataFinal} 
                        carregando={true}
                        loading={isLoading}/>
                </div>
                <div className="flex gap-4">
                    <CardDashGrafico
                        className="w-3/6"
                        data={dataGrafico?.data?.find((e) => e?.tipo == 1)}
                        textoLegenda="Média de posição"
                        tituloAtual="Mês atual"
                        tituloAnterior="Mês anterior"
                        titulo="Ranqueamento Geral"
                        descricao="Ranqueamento de posições na SERP (Página de Resultados do Mecanismo de Busca) refere-se à ordem em que os resultados de pesquisa aparecem após uma consulta no Google ou em outros mecanismos de busca. Quanto mais alta a posição de um site ou página, maior a visibilidade e a probabilidade de cliques pelos usuários." />
                    <CardDashGrafico
                        className="w-3/6"
                        data={dataGrafico?.data?.find((e) => e?.tipo == 2)}
                        tituloAtual="Nas últimas 24 horas"
                        tituloAnterior="No último mês"
                        titulo="Trafego de Usuários"
                        descricao="O tráfego de artigos em um blog Wordpress refere-se ao número de visitantes que acessam e interagem com os seus artigos. Aumentar o tráfego é fundamental para expandir a visibilidade do seu conteúdo e atrair mais leitores" />
                </div>
                <Typography component="base" className="p-[0.62rem] bg-grey-medium text-neutras-white mt-6 text-center w-full justify-center font-bold rounded-lg">VISÃO GERAL DO ARTIGO</Typography>

                <div className="bg-neutras-grey-light mt-6 py-3 px-4 rounded-lg flex">
                    <ItemTabelaVisaoGeral titulo="PALAVRA-CHAVE" valor={data?.data?.palavra}/>
                    <ItemTabelaVisaoGeral titulo="DATA DA PUBLICAÇÃO" valor={data?.data?.dataPublicacao && format(data?.data?.dataPublicacao, "dd/MM/yyyy")}/>
                    <ItemTabelaVisaoGeral titulo="POSICIONAMENTO" valor={`Top ${data?.data?.posicao == 31 ? "30+" : data?.data?.posicao}`}/>
                    <ItemTabelaVisaoGeral titulo="ALCANCE DO ARTIGO TOTAL" valor={data?.data?.trafegoTotal?.toString()}/>
                </div>
                <div className="bg-neutras-grey-light mt-6 py-3 px-4 rounded-lg flex">
                    <ItemTabelaVisaoGeral titulo="NOTA DE SEO" component="progressBar" valor={data?.data?.seo}/>
                    <ItemTabelaVisaoGeral titulo="NOTA DE LEGIBILIDADE" component="progressBar" valor={data?.data?.legibilidade}/>
                    <ItemTabelaVisaoGeral titulo="TRÁFEGO NAS ÚLTIMAS 24 H" valor={data?.data?.trafego?.toString()}/>
                    <ItemTabelaVisaoGeral titulo="DESEMPENHO DO ARTIGO" component="icon" valor={data?.data?.desempenho}/>
                </div>
            </Modal>
        </div>
    )
}
